export default "__VITE_ASSET__bcefeb7f__"